<template>
  <div class="all">
    <div class="head clearfix yp-topbar">{{nickName}}</div>
    <div class="circleContent yp-topbar">
      <canvas id="myCanvas"></canvas>
      <div class="contentNum">
        <div>
          <span class="info">已用:{{usedSize}}</span>
          <span class="info">容量:{{quota}}</span>
        </div>
      </div>
    </div>
    <ul class="meau_icon">
      <li>
        <router-link to="/collect/collect">
          <i class="iconfont icon-xingxing" style="color: #FFD606"></i>
          <p>个人收藏</p>
        </router-link>
      </li>
      <li>
        <router-link to="/myShare">
          <i class="iconfont icon-fenxiang" style="color:#FF5801"></i>
          <p>我的分享</p>
        </router-link>
      </li>
      <li>
        <router-link to="/recycle/recycle">
          <i class="iconfont icon-huishouzhan" style="color: #13A1FF"></i>
          <p>回收站</p>
        </router-link>
      </li>
    </ul>
    <div class="meau_list">
      <mt-cell title="他人分享" is-link to="/otherShare"></mt-cell>
      <mt-cell title="群组管理" is-link to="/groupManage"></mt-cell>
      <mt-cell title="个人设置" is-link to="/more/showinfo"></mt-cell>
      <mt-cell title="操作日志" is-link to="/log/log"></mt-cell>
      <mt-cell title="帐号安全" is-link to="/more/accountsafe"></mt-cell>
    </div>
    <div :class="{login_out: isIphoneX}" class="off">

      <mt-button size="large" @click="loginOut">退出登录</mt-button>
    </div>
    <tabbar :id="4"></tabbar>
    <!--二次退出-->
    <mt-actionsheet
      :actions="actions"
      v-model="sheetVisible"
      class="loginout">
    </mt-actionsheet>
  </div>
</template>
<script type="text/ecmascript-6">
  import apis from '../../apis/index'
  import cloudApi from '../../apis/cloudStorageApi'
  import { bytesToSize } from '../../assets/js/tools'
  import tabbar from '../../components/tabbar.vue'

  export default {
    data () {
      return {
        isIphoneX: false,
        usedSize: '',
        quota: '',
        fsnum: '',
        isLink: true,
        nickName: '',
        actions: [{
          name: '确认退出登录吗',
          method: ''
        }, {
          name: '确认退出',
          method: this.loginout
        }],
        sheetVisible: false
      }
    },
    components: {
      bytesToSize,
      tabbar
    },
    created () {
      this._conmentNum()
      this.nickName = JSON.parse(sessionStorage.mobileData).nickName
      let isx = this.$store.state.isIphoneX
      this.isIphoneX = isx
    },
    updated () {
      this.rotateCircle()
    },
    methods: {
      rotateCircle () {
        function drawRing (w, h, val) {
          // 先创建一个canvas画布对象，设置宽高
          var c = document.getElementById('myCanvas')
          var ctx = c.getContext('2d')
          ctx.canvas.width = w
          ctx.canvas.height = h
          ctx.beginPath()
          ctx.lineWidth = 10// 10px
          ctx.strokeStyle = '#97beee'
          // arc()方法创建弧/曲线（用于创建圆或部分圆）arc(圆心x,圆心y,半径,开始角度,结束角度)
          ctx.arc(50, 50, 40, 0, 2 * Math.PI)
          // 绘制已定义的路径
          ctx.stroke()
          // 绘制根据百分比变动的环
          ctx.beginPath()
          ctx.lineWidth = 10
          ctx.strokeStyle = '#ffd329'
          // 设置开始处为0点钟方向（-90*Math.PI/180）
          // x为百分比值（0-100）
          ctx.arc(50, 50, 40, -90 * Math.PI / 180, (val * 3.6 - 90) * Math.PI / 180)
          ctx.stroke()
          // 绘制中间的文字
          ctx.font = '20px Arial'
          ctx.fillStyle = '#ffffff'
          ctx.textBaseline = 'middle'
          ctx.textAlign = 'center'
          ctx.fillText(val + '%', 50, 50)
        }

        drawRing(100, 100, this.fsnum)
      },
      _conmentNum () {
        var _this = this
        apis.request(cloudApi.show, {}).then(function (response) {
          window.sessionStorage.mobileData = JSON.stringify(response.data)
          _this.usedSize = bytesToSize(response.data.usedSize)
          _this.quota = bytesToSize(response.data.quota)
          let data = response.data
          // if (data.usedSize < 536870912 & data.usedSize > 0) {
          //   _this.fsnum = 1
          // } else
          if (data.usedSize === 0) {
            _this.fsnum = 0
          } else {
            _this.fsnum = (data.usedSize / data.quota) * 100 + ''
            _this.fsnum = _this.fsnum.substring(0, 4)
          }
        })
      },
      loginOut () {
        this.sheetVisible = true
      },
      loginout () {
        var _this = this
        apis.request(cloudApi.logout, {}).then(function () {
          sessionStorage.removeItem('mobileData')
          // window.localStorage.clear()
          _this.$router.push('/login')
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .iconfont {
    font-size: .62rem;
    display: block;
  }

  html, body {
    /*overflow: hidden;*/
    height: 100%;
  }

  .all {
    height: 100%;
    padding-top: 1.28rem;
    background: #F7F7FA;
  }

  .head {
    position: fixed;
    top: 0;
    height: 1rem;
    width: 100%;
    /*padding-top: 0.32rem;*/
    font-size: .36rem;
    color: #fff;
    line-height: 1rem;
    text-align: center;
  }

  .circleContent {
    background-size: 100%;
    text-align: center;
    box-sizing: border-box;
    height: 3rem;
    margin-top: .9rem;
    position: absolute;
    top: -0.1rem;
    width: 100%;
    /*padding: .2rem 2.97rem .6rem 2.97rem;*/
    /*padding: .2rem 0 1rem 0;*/
  }

  .circle {
    width: 2.32rem;
    height: 2.32rem;
    border-radius: 50%;
    border: solid 10px #ffffff;
    display: inline-block;
  }

  .circle > span {
    display: inline-block;
    font-size: .64rem;
    padding: .6rem 0;
    color: #fff;
  }

  .contentNum {
    padding: 0rem 1.06rem;
    /*margin-top: .29rem;*/
    div {
      overflow: hidden;
    }
  }

  .contentNum div > span:nth-child(1) {
    float: left;
  }

  .contentNum div > span:nth-child(2) {
    float: right;
  }

  .info {
    font-size: .3rem;
    color: #ffffff;
    text-align: left;
    white-space: nowrap;
    /*position: absolute;*/
    /*left: 2.5rem;*/
    font-weight: 500;
    margin-top: .2rem
  }

  .meau_icon {
    background-color: #fff;
    overflow: hidden;
    border-bottom: 1px solid #e5e5e5;
    text-align: center;
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    margin-top: 2.5rem;
  }

  .meau_icon > li {
    width: 33%;
    float: left;
    border-left: 1px solid #e5e5e5;
    padding: .3rem 0;
  }

  .meau_icon > li img {
    height: .48rem;
  }

  .meau_icon > li p {
    margin-top: .27rem;
    color: #1d1f22;
    font-size: .28rem;
  }

  .meau_list {
    /*margin-top: .2rem;*/
    text-align: left;
    font-size: .28rem;
    position: absolute;
    top: 5.8rem;
    width: 100%;
  }

  .off {
    margin-top: .4rem;
    position: fixed;
    width: 100%;
    bottom: 1.2rem;
  }

  .mint-button--default {
    color: #e64340 !important;
    background-color: #fff !important;
  }

  .mint-button {
    height: 1rem !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    border-top: 1px solid #e5e5e5 !important;
    border-bottom: 1px solid #e5e5e5 !important;
  }
</style>
<style lang="scss">
  .loginout li:nth-of-type(1) {
    color: #999999 !important;
    font-size: .28rem !important;
  }

  .loginout li:nth-of-type(2) {
    color: #E64340 !important;
    font-size: .36rem !important;
  }

  .loginout a {
    color: #1D1F22 !important;
    font-size: .36rem !important;
  }
  .mint-cell-wrapper {
    background-image: -webkit-linear-gradient(top,#e5e5e5,#e5e5e5 50%,transparent 0);
    background-image: linear-gradient(180deg,#e5e5e5,#e5e5e5 50%,transparent 0);
  }
  .login_out {
    bottom: 1.7rem!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/more/setinfo.vue